import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ModalAction from '@/components/ModalAction';
import { fetchAPI } from '@/api';
import { Loader } from '@/components/Loader';
import classNames from 'classnames';

const DeletePlanModal = ({ modalOpen, setModalOpen, setIsLoading, isLoading, plan, onDelete }: any) => {
	const onClearModal = () => {
		setModalOpen(false);
		setTimeout(() => {
			setIsLoading(false);
		}, 400);
	};

	return (
		<ModalAction
			id="delete-plan-modal"
			modalOpen={modalOpen}
			setModalOpen={setModalOpen}
			onModalClose={() => onClearModal()}
			size={undefined}
		>
			<h2 className="h2 mb-4 pr-16 md:pr-20 leading-[0.9]">
				Are you sure you want to delete {plan.name} plan?
			</h2>
			{isLoading && (
				<div className="text-brand-green w-[50px] h-[50px] my-1 mx-auto">
					<Loader />
				</div>
			)}
			<div className={classNames(isLoading && 'hidden')}>
				<button className="btn-primary w-full mt-8" onClick={() => onClearModal()}>
					<span className="pointer-events-none">Keep</span>
				</button>
				<button className="btn-primary-inverted w-full mt-4" onClick={() => onDelete()} disabled={isLoading}>
					<span className="pointer-events-none">Delete</span>
				</button>
			</div>
		</ModalAction>
	);
};

export default DeletePlanModal;
